import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import React from "react";
import { useCallback } from "react";
import type { MenuOptionType } from "../../../../../controls";
import type { Operator } from "../../models/Operator";

type Props = {
	handleNewOperator: () => void;
	editOperator: (operator: Operator) => void;
	deleteOperator: (operator: Operator) => void;
};

export const useOperatorsOptionsFunctions = ({
	handleNewOperator,
	editOperator,
	deleteOperator,
}: Props) => {
	const getMenuOptions = useCallback(
		(data?: Operator) => {
			let options: MenuOptionType[] = [
				{
					name: "New Operator",
					key: "new_operator",
					onClick: () => {
						handleNewOperator();
					},
					icon: <PlaylistAddIcon />,
				},
			];

			if (!data) {
				return options;
			}

			options = options.concat([
				{
					name: "Edit Operator",
					key: "edit_operator",
					onClick: () => {
						editOperator(data);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Operator",
					key: "delete_operator",
					onClick: () => {
						deleteOperator(data);
					},
					icon: <DeleteIcon />,
				},
			]);

			return options;
		},
		[deleteOperator, editOperator, handleNewOperator],
	);

	return { getMenuOptions };
};
